import { render, staticRenderFns } from "./AccountCards.vue?vue&type=template&id=706845d8&scoped=true&"
import script from "./AccountCards.vue?vue&type=script&lang=js&"
export * from "./AccountCards.vue?vue&type=script&lang=js&"
import style0 from "./AccountCards.vue?vue&type=style&index=0&id=706845d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706845d8",
  null
  
)

export default component.exports